const isTokenValid = (token) => {
  if (token === null || token === undefined) return false;

  if (typeof token === 'string') {
    return token.length > 0;
  }

  if (typeof token === 'object' && token.expires) {
    const now = new Date();
    const secondsSinceEpoch = Math.round(now.getTime() / 1000);
    return token.expires > secondsSinceEpoch;
  }

  return false;
};

export default isTokenValid;
